<template>
  <div class="container d-flex flex-column align-items-center">
    <v-wait :for="loaderName">
      <template slot="waiting">
        <half-circle-spinner/>
      </template>
      <div>
        <div class="text-center">
          <b>Define Your Desired Career Terms and Engage</b>
        </div>
        <div>
          <ul class="p-0 mt-3">
          <li><p class="mb-0">Use Phairify's specialty intel to define the terms of your perfect jobs.</p></li>
            <li><p class="mb-0">Anonymously post your desired terms on Phairify's exchange for employers to match.</p></li>
            <li><p class="mb-0">Engage with employers that meet your terms.</p></li>
            <li><p class="mb-0">Review Phairify's exchange to see real time job activity in your specialty.</p></li>
          </ul>
        </div>
        <div class="text-center">
          <p>Click ‘Begin Study’ on the <a href="#/user/surveyHome">Share page</a> and complete the study to access these tools.</p>
        </div>
      </div>
    </v-wait>
  </div>
</template>

<script>
import Api from '@/providers/Api';
import { HalfCircleSpinner } from 'epic-spinners';

export default {
  name: 'ExchangeStudyNotCompleted',
  components: {
    HalfCircleSpinner,
  },
  data: function () {
    return {
      content: null,
    };
  },
  computed: {
    loaderName: function () {
      return this.$options.name + '_loading';
    },
  },
  created: async function () {
    this.$wait.start(this.loaderName);
    try {
      this.content = await Api.getIcoNoStudyCompletedDynamicContent();
    } catch {
      this.$toasted.error(
        'Unable to upload page content. Please try again later',
        { duration: 3000 }
      );
    } finally {
      this.$wait.end(this.loaderName);
    }
  },
};
</script>

<style scoped></style>
